import {
  ChartDimensionSelect,
  useDimensionHandlers,
} from '@/features/(charts)/chart-controller/ui/components/chart-dimension-select';

type Props = {
  chartInfo: ChartContextProps;
};
export default function CustomChartDataset({ chartInfo }: Props) {
  const {
    isColumn,
    targetField,
    handleFieldChange,
    handleFieldItemChange,
    handleTopLabelClick,
    handleHeaderTopLabelClick,
    handleClear,
  } = useDimensionHandlers({ chartInfo });

  return (
    <div className="space-y-3 p-3 bg-card rounded-md">
      <ChartDimensionSelect.FieldMenu
        targetFieldType={targetField.type}
        onFieldChange={handleFieldChange}
      />
      <ChartDimensionSelect.FieldSelector
        chartInfo={chartInfo}
        targetField={targetField}
        switchFlag={0}
        isColumn={isColumn}
        onFieldItemChange={handleFieldItemChange}
        onTopLabelClick={handleTopLabelClick}
        onHeaderTopLabelClick={handleHeaderTopLabelClick}
        onClear={handleClear}
        allowTop
      />
    </div>
  );
}
